import { registry } from "@/lib/registry";

// STATIC_REGISTRY_START

/**
 * Initialize the static component registry.
 * This function is auto-generated by the staticRegistry Vite plugin.
 *
 * DO NOT EDIT THIS FUNCTION MANUALLY - it will be overwritten on next build.
 *
 * Components registered: carousels.crossSellCarousel, carousels.editorialCarousel, carousels.editorialCarouselCardPD, carousels.eventCourseStoreCard, carousels.groupedCarousel, carousels.groupedCarouselGroup, carousels.locationImageCard, carousels.productCarousel, carousels.productCarousel, carousels.productRecommendations, carousels.squareCardCarousel, carousels.squareCarouselCard, content.becomeSupplierForm, content.cardListings, content.cardMultiImages, content.drawerInfo, content.eatalyClubPage, content.editorialArticleAsideComponent, content.editorialAsideResourceItem, content.editorialAsideResources, content.editorialCarouselOverlay, content.editorialCarouselOverlayCard, content.editorialCarouselProductCardPD, content.editorialFaqHelpHub, content.editorialForm, content.editorialFormFieldOption, content.editorialHeaderPress, content.editorialHelpCardRow, content.editorialHelpCardRows, content.editorialHelpIconCard, content.editorialHelpLongCard, content.editorialJobOpportunities, content.editorialLocationContacts, content.editorialLocationContactsSection, content.editorialPeopleBanner, content.editorialPromoBanner, content.editorialSeoLinkingLink, content.editorialSeoLinkingSection, content.editorialStoreInfo, content.editorialSupportContactForm, content.editorialTextMedia, content.editorialTextOnly, content.eventsForm, content.forBusinessForm, content.giftCardAccordionItem, content.giftCardHowItWorks, content.giftCardProductTabs, content.heroBanner, content.heroModules, content.heroModulesCard, content.heroText, content.heroTextMedia, content.inspirationHeader, content.locationChefItem, content.locationDirectionsAccordionItem, content.locationEditorialCard, content.locationEditorialCarousel, content.mediaFullBleed, content.memberGetMemberPage, content.menu, content.numbers, content.numbersItem, content.productTile, content.productTileEataly, content.recommendedCourse, content.recommendedRecipe, content.seoText, content.socialLink, content.socialLinks, content.theSelection, layout.editorialTabs, layout.editorialViewportWrapper, navigation.editorialMenuAltro, navigation.editorialMenuAltroLink, navigation.editorialMenuBanner, navigation.editorialMenuBannerItem, navigation.editorialMenuCorsiEventi, navigation.editorialMenuCorsiEventiItem, navigation.editorialMenuRistoranteCard, navigation.editorialMenuRistoranti, navigation.editorialMenuSpesaOnline, navigation.editorialMenuSpesaOnlineLink, navigation.footerCertificationRegion, navigation.footerLegalRegion, navigation.footerLink, navigation.footerLinkRegion, navigation.footerLinkRowRegion, navigation.footerMainRegion, navigation.footerNewsletter, navigation.footerPaymentMethodIcon, navigation.footerPaymentMethodsRegion, navigation.footerSocialLink, navigation.footerSocialRegion, navigation.pillarNavigation, navigation.pillarNavigationTab, navigation.preHeaderLayout, navigation.siteFooter, primitives.editorialCta, primitives.editorialFaqCallout, primitives.editorialFaqHelpResults, primitives.editorialFaqHelpSearch, primitives.editorialHeaderPressContact, primitives.editorialMarkup, primitives.editorialRichText, primitives.editorialSvg, primitives.markdown, primitives.openTableReservation, primitives.openTableWidget, primitives.pdImage, primitives.squareCardPdfLink, primitives.squareCardQodeupLink, recipes.drawerListEditorialCard, recipes.editorialDrawerListCard, registration.registrationBenefitCard, registration.registrationBenefitsSection, registration.registrationEditorial, registration.registrationEditorialBullet, tab.infoHoursTab, tab.listingTab, tab.locationChefTab, tab.locationDirectionsTab, tab.richTextAndImageTab
 */
export function initializeRegistry(targetRegistry = registry): void {
	targetRegistry.registerImporter(
		"carousels.crossSellCarousel",
		() => import("../components/carousel-cross-sell/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"carousels.editorialCarousel",
		() => import("../components/carousel-editorial/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"carousels.editorialCarouselCardPD",
		() =>
			import(
				"../components/carousel-editorial-card/editorial-carousel-card-pd"
			),
		{ loader: "loader" },
	);
	targetRegistry.registerImporter(
		"carousels.eventCourseStoreCard",
		() =>
			import("../components/carousel-editorial-card/event-course-store-card"),
		{ loader: "loader" },
	);
	targetRegistry.registerImporter(
		"carousels.groupedCarousel",
		() => import("../components/carousel-grouped/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"carousels.groupedCarouselGroup",
		() => import("../components/carousel-grouped/grouped-carousel-group"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"carousels.locationImageCard",
		() => import("../components/carousel-square-card/image-card"),
	);
	targetRegistry.registerImporter(
		"carousels.productCarousel",
		() => import("../components/product-carousel-custom/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"carousels.productCarousel",
		() => import("../components/product-carousel/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"carousels.productRecommendations",
		() => import("../components/carousel-product-recommendations/index"),
		{ loader: "loader" },
	);
	targetRegistry.registerImporter(
		"carousels.squareCardCarousel",
		() => import("../components/carousel-square-card/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"carousels.squareCarouselCard",
		() => import("../components/carousel-square-card/square-card"),
		{ loader: "loader" },
	);
	targetRegistry.registerImporter(
		"content.becomeSupplierForm",
		() => import("../components/editorial-form/become-supplier-form"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.cardListings",
		() => import("../components/card-listings/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.cardMultiImages",
		() => import("../components/card-multi-images/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.drawerInfo",
		() => import("../components/drawer-info/index"),
	);
	targetRegistry.registerImporter(
		"content.eatalyClubPage",
		() => import("../components/eataly-club/eataly-club-page"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialArticleAsideComponent",
		() => import("../components/article-with-aside/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialAsideResourceItem",
		() => import("../components/article-with-aside/aside/resource-item"),
	);
	targetRegistry.registerImporter(
		"content.editorialAsideResources",
		() => import("../components/article-with-aside/aside/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialCarouselOverlay",
		() => import("../components/editorial-carousel-overlay/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialCarouselOverlayCard",
		() => import("../components/editorial-carousel-overlay/card"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialCarouselProductCardPD",
		() =>
			import(
				"../components/carousel-editorial-card/editorial-carousel-product-card-pd"
			),
		{ loader: "loader" },
	);
	targetRegistry.registerImporter(
		"content.editorialFaqHelpHub",
		() => import("../components/editorial-faq-help-hub/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialForm",
		() => import("../components/editorial-form/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialFormFieldOption",
		() => import("../components/editorial-form/editorial-form-field-option"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialHeaderPress",
		() => import("../components/editorial-header-press/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialHelpCardRow",
		() => import("../components/editorial-help-card-rows/row"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialHelpCardRows",
		() => import("../components/editorial-help-card-rows/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialHelpIconCard",
		() => import("../components/editorial-help-icon-card/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialHelpLongCard",
		() => import("../components/editorial-help-long-card/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialJobOpportunities",
		() => import("../components/editorial-job-opportunities/index"),
	);
	targetRegistry.registerImporter(
		"content.editorialLocationContacts",
		() => import("../components/editorial-location-contacts/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialLocationContactsSection",
		() => import("../components/editorial-location-contacts/section"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialPeopleBanner",
		() => import("../components/editorial-people-banner/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialPromoBanner",
		() => import("../components/editorial-promo-banner/index"),
	);
	targetRegistry.registerImporter(
		"content.editorialSeoLinkingLink",
		() => import("../components/seo-linking/seo-linking-link"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialSeoLinkingSection",
		() => import("../components/seo-linking/seo-linking"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialStoreInfo",
		() => import("../components/editorial-store-info/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialSupportContactForm",
		() => import("../components/editorial-support-contact-form/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialTextMedia",
		() => import("../components/editorial-text-media/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.editorialTextOnly",
		() => import("../components/editorial-text-only/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.eventsForm",
		() => import("../components/editorial-form/events-form"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.forBusinessForm",
		() => import("../components/editorial-form/for-business-form"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.giftCardAccordionItem",
		() =>
			import(
				"../components/product-view-custom/gift-card-tabs/gift-card-accordion-item"
			),
	);
	targetRegistry.registerImporter(
		"content.giftCardHowItWorks",
		() =>
			import(
				"../components/product-view-custom/gift-card-tabs/gift-card-how-it-works"
			),
	);
	targetRegistry.registerImporter(
		"content.giftCardProductTabs",
		() => import("../components/product-view-custom/gift-card-tabs/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.heroBanner",
		() => import("../components/hero-banner/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.heroModules",
		() => import("../components/hero-modules/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.heroModulesCard",
		() => import("../components/hero-modules/hero-modules-card"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.heroText",
		() => import("../components/hero-text/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.heroTextMedia",
		() => import("../components/hero-text-media/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.inspirationHeader",
		() => import("../components/folder-listing-header/folder-listing-header"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.locationChefItem",
		() => import("../components/tabs/location-chef-item"),
	);
	targetRegistry.registerImporter(
		"content.locationDirectionsAccordionItem",
		() => import("../components/tabs/location-directions-accordion-item"),
	);
	targetRegistry.registerImporter(
		"content.locationEditorialCard",
		() => import("../components/location-editorial/location-editorial-card"),
	);
	targetRegistry.registerImporter(
		"content.locationEditorialCarousel",
		() => import("../components/location-editorial/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.mediaFullBleed",
		() => import("../components/editorial-media/index"),
	);
	targetRegistry.registerImporter(
		"content.memberGetMemberPage",
		() => import("../components/member-get-member/member-get-member-page"),
	);
	targetRegistry.registerImporter(
		"content.menu",
		() => import("../components/menu/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.numbers",
		() => import("../components/numbers/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.numbersItem",
		() => import("../components/numbers/numbers-item"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.productTile",
		() => import("../components/product-tile/index"),
	);
	targetRegistry.registerImporter(
		"content.productTileEataly",
		() => import("../components/product-tile-eataly/index"),
		{ loader: "loader" },
	);
	targetRegistry.registerImporter(
		"content.recommendedCourse",
		() => import("../components/recommended-course/index"),
		{ loader: "loader" },
	);
	targetRegistry.registerImporter(
		"content.recommendedRecipe",
		() => import("../components/recommended-recipe/index"),
		{ loader: "loader" },
	);
	targetRegistry.registerImporter(
		"content.seoText",
		() => import("../components/seo-text/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.socialLink",
		() => import("../components/social-links/social-link"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.socialLinks",
		() => import("../components/social-links/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"content.theSelection",
		() => import("../components/the-selection/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"layout.editorialTabs",
		() => import("../components/tabs/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"layout.editorialViewportWrapper",
		() => import("../components/viewport-wrapper/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuAltro",
		() => import("../components/editorial-menu/other/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuAltroLink",
		() => import("../components/editorial-menu/other/link"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuBanner",
		() => import("../components/editorial-menu/banner/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuBannerItem",
		() => import("../components/editorial-menu/banner/item"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuCorsiEventi",
		() => import("../components/editorial-menu/events-courses/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuCorsiEventiItem",
		() => import("../components/editorial-menu/events-courses/item"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuRistoranteCard",
		() => import("../components/editorial-menu/restaurants/card"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuRistoranti",
		() => import("../components/editorial-menu/restaurants/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuSpesaOnline",
		() => import("../components/editorial-menu/online-shopping/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.editorialMenuSpesaOnlineLink",
		() => import("../components/editorial-menu/online-shopping/link"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerCertificationRegion",
		() =>
			import("../components/footer-custom/regions/footer-certification-region"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerLegalRegion",
		() => import("../components/footer-custom/regions/footer-legal-region"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerLink",
		() => import("../components/footer-custom/footer-link"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerLinkRegion",
		() => import("../components/footer-custom/regions/footer-link-region"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerLinkRowRegion",
		() => import("../components/footer-custom/regions/footer-link-row-region"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerMainRegion",
		() => import("../components/footer-custom/regions/footer-main-region"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerNewsletter",
		() =>
			import(
				"../components/footer-custom/regions/newsletter/footer-newsletter-region"
			),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerPaymentMethodIcon",
		() => import("../components/footer-custom/footer-payment-methods-icon"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerPaymentMethodsRegion",
		() =>
			import(
				"../components/footer-custom/regions/footer-payment-methods-region"
			),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerSocialLink",
		() => import("../components/footer-custom/footer-social-link"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.footerSocialRegion",
		() => import("../components/footer-custom/regions/footer-social-region"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.pillarNavigation",
		() => import("../components/pillar-navigation/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.pillarNavigationTab",
		() => import("../components/pillar-navigation/pillar-navigation-tab"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.preHeaderLayout",
		() => import("../components/pre-header-layout/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"navigation.siteFooter",
		() => import("../components/footer-custom/index"),
	);
	targetRegistry.registerImporter(
		"primitives.editorialCta",
		() => import("../components/editorial-cta/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"primitives.editorialFaqCallout",
		() => import("../components/editorial-faq-callout/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"primitives.editorialFaqHelpResults",
		() => import("../components/editorial-faq-help-results/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"primitives.editorialFaqHelpSearch",
		() => import("../components/editorial-faq-help-search/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"primitives.editorialHeaderPressContact",
		() => import("../components/editorial-header-press/header-press-contact"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"primitives.editorialMarkup",
		() => import("../components/editorial-markup/index"),
	);
	targetRegistry.registerImporter(
		"primitives.editorialRichText",
		() => import("../components/editorial-rich-text/index"),
	);
	targetRegistry.registerImporter(
		"primitives.editorialSvg",
		() => import("../components/editorial-svg/index"),
	);
	targetRegistry.registerImporter(
		"primitives.markdown",
		() => import("../components/markdown/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"primitives.openTableReservation",
		() => import("../components/open-table-reservation/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"primitives.openTableWidget",
		() => import("../components/open-table-widget/index"),
		{ loader: "loader", fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"primitives.pdImage",
		() => import("../components/dynamic-image/index"),
	);
	targetRegistry.registerImporter(
		"primitives.squareCardPdfLink",
		() => import("../components/carousel-square-card/square-card-pdf-link"),
	);
	targetRegistry.registerImporter(
		"primitives.squareCardQodeupLink",
		() => import("../components/carousel-square-card/square-card-qodeup-link"),
	);
	targetRegistry.registerImporter(
		"recipes.drawerListEditorialCard",
		() =>
			import(
				"../components/recipe-preparation-card/drawer-list-editorial-card"
			),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"recipes.editorialDrawerListCard",
		() => import("../components/recipe-preparation-card/index"),
		{ fallback: "fallback" },
	);
	targetRegistry.registerImporter(
		"registration.registrationBenefitCard",
		() => import("../components/registration/registration-benefit-card"),
	);
	targetRegistry.registerImporter(
		"registration.registrationBenefitsSection",
		() => import("../components/registration/registration-benefits-section"),
	);
	targetRegistry.registerImporter(
		"registration.registrationEditorial",
		() => import("../components/registration/registration-editorial"),
	);
	targetRegistry.registerImporter(
		"registration.registrationEditorialBullet",
		() => import("../components/registration/registration-editorial-bullet"),
	);
	targetRegistry.registerImporter(
		"tab.infoHoursTab",
		() => import("../components/tabs/info-hours-tab"),
	);
	targetRegistry.registerImporter(
		"tab.listingTab",
		() => import("../components/tabs/listing-tab"),
	);
	targetRegistry.registerImporter(
		"tab.locationChefTab",
		() => import("../components/tabs/location-chef-tab"),
	);
	targetRegistry.registerImporter(
		"tab.locationDirectionsTab",
		() => import("../components/tabs/location-directions-tab"),
	);
	targetRegistry.registerImporter(
		"tab.richTextAndImageTab",
		() => import("../components/tabs/rich-text-image-tab"),
	);
}

// STATIC_REGISTRY_END
